import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { Link } from 'react-router-dom';
import './index.scss';

import ArticleListPage from '../../Series/ArticleListPage';
import SviCaseStoryList from '../SviCaseStoryList';
import sviBanner from '../../../images/article-svi.png';

class SviStoryList extends Component {
	componentDidMount() {
		window.scrollTo(0, 0);
		this.props.onLoadHeaderColor('BLUE');
		this.props.onLoadHeaderTheme('LIGHT');
		this.props.onLoadShowLanguage('HIDE');

		const breadcrumb = [
			{ name: '首頁', href: '/' },
			{ name: '社會脆弱度', href: '/evaluation/svi' },
			{ name: '主題館', href: '/evaluation/svi/categories' },
		];
		this.props.onLoadShowBreadcrumb('SHOW', breadcrumb);
	}

	render() {
		const pathname = this.props.location ? this.props.location.pathname : '';
		const isStoriesTab = pathname === '/evaluation/svi/stories';
		const isCategoriesTab = !isStoriesTab;

		return (
			<React.Fragment>
				<Helmet>
					<title>{isStoriesTab ? '案例故事' : '社會脆弱度評估主題館'} - 減災動資料</title>
				</Helmet>
				<div className="page-story">
					<main className="article-list-page">
						<section className="heading article-section article-heading blue" style={{ backgroundImage: `url(${sviBanner})` }}>
							<div className="mainheading type-heading -h4 -ch">社會脆弱度評估主題館</div>
							<div className="subheading type-text -en -lg">Discussions Extended from Social Vulnerability Assessment for Disasters</div>
						</section>

						<section className="story-section">
							<div className="svi-pavilion-tabs">
								<ul className="nav nav-tabs" role="tablist">
									<li className="nav-item">
										{isCategoriesTab ? (
											<span className="nav-link active">社會脆弱度評估文章</span>
										) : (
											<Link className="nav-link" to="/evaluation/svi/categories">社會脆弱度評估文章</Link>
										)}
									</li>
									<li className="nav-item">
										{isStoriesTab ? (
											<span className="nav-link active">案例故事</span>
										) : (
											<Link className="nav-link" to="/evaluation/svi/stories">案例故事</Link>
										)}
									</li>
								</ul>
							</div>

							<div className="tab-content">
								{isCategoriesTab && (
									<div className="tab-pane show active" role="tabpanel">
										<div className="story-search-block">
											<div className="story-search-block-inner"></div>
										</div>
										<div className="story-article-list-wrap">
											<ArticleListPage {...this.props} />
										</div>
									</div>
								)}
								{isStoriesTab && (
									<div className="tab-pane show active" role="tabpanel">
										<SviCaseStoryList />
									</div>
								)}
							</div>
						</section>
					</main>
				</div>
			</React.Fragment>
		);
	}
}

export default SviStoryList;
